'use client';

import Link from 'next/link';
import { trackEvent } from '@/lib/analytics';
import {
  RELATED_IN_EXPLORE_CLICKED,
  type RelatedInExploreClickedProps,
} from '@/lib/analytics/explore-events';

type Props = {
  fromPage: string;
  toPage: string;
  direction: RelatedInExploreClickedProps['direction'];
  href: string;
  className?: string;
  children: React.ReactNode;
} & Record<string, unknown>;

export function TrackedRelatedLink({ fromPage, toPage, direction, href, className, children, ...rest }: Props) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() =>
        trackEvent(RELATED_IN_EXPLORE_CLICKED, {
          from_page: fromPage,
          to_page: toPage,
          direction,
        })
      }
      {...rest}
    >
      {children}
    </Link>
  );
}
